import React from 'react'
import styled from 'styled-components'
import { IconBin } from '../../../constants/icons'
import Colors from '../../../constants/Colors'
import { NOT_FOUND_LOTTERY_ID } from '../constants'

const FoundLotteryID = ({ foundLotteryIds, handleClickRemoveSomeLottery }) => {

  const handleCopyAllLotteryID = () => {
    let text = ''

    foundLotteryIds.forEach((lotto) => {
      if (lotto.lotteryId !== '' && lotto.lotteryId !== NOT_FOUND_LOTTERY_ID) {
        text += lotto.lotteryId + '\n'
      }
    })

    navigator.clipboard.writeText(text)
  }

  return (
    <LotteryIdContent>
      <div className="lottery-header">
        <div className="lottery-title">ลอตเตอรี่ที่สแกนสำเร็จ ทั้งหมด {foundLotteryIds.length} ใบ</div>
        <button onClick={handleCopyAllLotteryID} className="copy-lottery-ids">คัดลอกตัวเลขทั้งหมด</button>
      </div>
      <div className="lottery-content">
        {foundLotteryIds.map((lotto) => {
          return (
            <div key={lotto.url} className="lottery-box" >
              <div onClick={() => handleClickRemoveSomeLottery(lotto.index)} className="lottery-overlay-color">
                <span className="lottery-icon-box">
                  <IconBin fill={Colors.WHITE} />
                </span>
                <div className="lottery-overlay"></div>
                <img src={lotto.url} alt="img lottery" className="lottery-image" />
              </div>
              <div className="lottery-id">{lotto.lotteryId}</div>
            </div>
          )
        })}
      </div>
    </LotteryIdContent>
  )
}

export default FoundLotteryID

const LotteryIdContent = styled.div`
  .lottery-header {
    display: flex;
    justify-content: space-between;
    margin: 1em 0 1em 0;

    .lottery-title {
      font-family: Prompt-SemiBold;
      line-height: 24px;
      font-size: 16px;
      flex: 1;
    }

    .copy-lottery-ids {
      flex: 1;
      font-size: 1em;
      font-weight: bold;
      padding: 0.25em 1em;
      border-radius: 3px;
      color: ${Colors.WHITE};
      border: 2px solid ${Colors.GREEN};
      background-color: ${Colors.GREEN};

      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }

      &:active {
        opacity: 0.8;
        color: ${Colors.SUPER_BLACK};
      }
    }
  }

  .lottery-content {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;

    .lottery-box {
      width: 24%;
      height: 24%;
      background-color: #fbfbfb;
      margin-bottom: 24px;
      text-align: center;
      border-radius: 8px;
      border: 1px solid ${Colors.LIGHT_GREY2};

      .lottery-overlay-color {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .lottery-icon-box {
          position: absolute;
          display: none;
          z-index: 1;
        }

        .lottery-overlay {
          display: none;
          border-radius: 8px;
          opacity: 0.5;
          width: 100%;
          height: 100%;
          position: absolute;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          background-color: ${Colors.SUPER_BLACK};
        }

        .lottery-image {
          width: 100%;
          border-radius: 8px;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        }

        &:hover {
          cursor: pointer;
  
          .lottery-overlay {
            display: block;
          }
          
          .lottery-icon-box {
            display: block;
          }
        }
      }

      .lottery-id {
        box-sizing: border-box;
        font-size: 16px;
        font-weight: normal;
        width: 100%;
        margin: 4px 0;
        text-align: center;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        color: ${Colors.DARK_GREY};
      }
    }
  }
`
